import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import ToggleButton from '~shared/components/toggle-button/ToggleButton.jsx';
import {
    onCustomerAcceptOddsFlagChange,
} from '~shared/utils/user';
import {
    selectAcceptOddsFlag,
} from '~Betslip/selectors/uiSelectors';
import {
    setAcceptOddsFlag,
} from '~Betslip/slices/uiSlice';
import {
    updateAcceptOddsFlag,
} from './utils';
import {
    isUserLoggedIn,
    getCustomerAcceptOddsFlag,
} from '~shared/utils/user';

import './styles.scss';

const AcceptOddsChanges = ({ source }) => {
    const [ t ] = useTranslation();
    const dispatch = useDispatch();

    const acceptOddsFlag = useSelector(selectAcceptOddsFlag);
    const gtmEnd = acceptOddsFlag ? 'accept-odds-movement-off' : 'accept-odds-movement-on';
    const acceptOddsGtm = `${source};accept-odds-switcher;${gtmEnd}`;

    useEffect(() => {
        const userAcceptOddsFlag = getCustomerAcceptOddsFlag();
        if (userAcceptOddsFlag !== acceptOddsFlag) {
            dispatch(setAcceptOddsFlag(userAcceptOddsFlag));
        }

        onCustomerAcceptOddsFlagChange((key, flag) => {
            dispatch(setAcceptOddsFlag(flag));
        });
    }, []);

    if (!isUserLoggedIn()) {
        return null;
    }

    return (
        <div className="fullslip__oddsChanges">
            <ToggleButton
                toggleText={t('betslip.accept_odds')}
                isToggleOn={acceptOddsFlag}
                gtmAttribute={acceptOddsGtm}
                setToggleState={updateAcceptOddsFlag}
            />
        </div>
    );
};

AcceptOddsChanges.propTypes = {
    source: PropTypes.string.isRequired,
};

export default AcceptOddsChanges;
